function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-1044-988H876v4055h-1920z"
}), React.createElement("path", {
  d: "M-1044-655H876v3657h-1920z"
}), React.createElement("g", {
  transform: "translate(-70 -52)"
}, React.createElement("path", {
  d: "M130.334 109.197h-2.028c.278-6.841-.643-13.493-2.742-19.787a.916.916 0 0 0-1.737.58c2.036 6.104 2.925 12.562 2.647 19.207h-2.92c-.041-2.862-.448-9.38-3.014-16.056.127-1.124.534-5.888-.796-12.245a48.16 48.16 0 0 1 2.94 6.002.916.916 0 0 0 1.696-.69c-2.722-6.684-5.883-10.486-6.23-10.894a.917.917 0 0 0-1.58.88 43.712 43.712 0 0 1 2.28 13.18c-1.536-2.969-3.42-5.582-5.63-7.793a.915.915 0 0 0-1.517.948c.129.396 1.622 5.063 2.501 10.676 1.119 7.14.75 12.649-1.06 15.992h-7.104c-.244-3.34-.702-6.54-1.369-9.52-.11-3.79-.593-10.31-2.432-17.223a64.416 64.416 0 0 1 2.24 4.084 67.809 67.809 0 0 1 6.367 19.605.916.916 0 0 0 1.808-.294 69.639 69.639 0 0 0-6.538-20.133c-3.07-6.104-5.907-9.51-6.026-9.653a.916.916 0 0 0-1.554.923c1.964 5.007 3.038 10.254 3.625 14.6-2.37-5.796-5.365-9.698-7.78-12.156-3.72-3.784-6.882-5.07-7.015-5.123a.916.916 0 0 0-.987 1.499c5.692 5.692 7.576 14.595 8.155 21.062.278 3.115.288 5.98.212 8.219-5.86-16.484-14.282-17.748-14.668-17.797a.916.916 0 0 0-.819 1.494c3.283 3.95 5.481 8.433 6.533 13.327a.916.916 0 1 0 1.79-.385 32.32 32.32 0 0 0-4.839-11.347c3.05 1.947 7.886 6.81 11.407 18.818h-5.867c.032-1.04.014-2.4-.147-3.98a.915.915 0 1 0-1.822.187c.155 1.515.17 2.813.137 3.793h-6.785a.916.916 0 1 0 0 1.831h50.668a.916.916 0 1 0 0-1.831zm-34.016 0c.191-1.895.553-6.707.043-12.453-.381-4.294-1.175-8.21-2.36-11.638-.792-2.29-1.76-4.366-2.897-6.214a27.802 27.802 0 0 1 1.97 1.822c3.226 3.283 7.544 9.29 9.791 19.273.648 2.88 1.096 5.974 1.338 9.21h-7.885zm18.862 0c2.92-6.638.871-17.42-.605-23.244 1.666 2.242 3.065 4.798 4.175 7.637 2.53 6.468 2.931 12.822 2.972 15.607h-6.542z",
  fill: "currentColor"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-70 -56.72)"
}, React.createElement("tspan", {
  x: 83.048,
  y: 138.719
}, "Trawa")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 70,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/trawa.2d8c9fc5.svg";
export { SvgComponent as ReactComponent };